import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=f6811352&scoped=true&"
import script from "./ContentView.vue?vue&type=script&lang=js&"
export * from "./ContentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6811352",
  null
  
)

export default component.exports